export class NewMoviesChart {
    all = 0;
    full: any = [];
}
